import { ITicketUserResponse } from "./ticket-user-response";

export interface ITicketResponse {
    data: {
        id: number;
        assignedUser: ITicketUserResponse;
        assignedCenterId: number;
        entityTypeId: number;
        entityType: number;
        ticketStatusId: number;
        ticketTypeId: number;
        tierLevelId: number;
    }
}